<template>
<div>
  <b-card >
    <template v-slot:header>
      <h4 class="mb-0"> <i class="fas fa-edit"></i>   Registro Nuevo Personal</h4>
    </template>

    <b-card-body>
      <div role="group">
                        <b-row>
                            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="4">
                                <label >Tipo Doc. de Identidad:</label>
                                <select class="custom-select" id="inlineFormCustomSelect" v-model="personal.doc" >                       
                                    <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select> 
                            </b-col>
                            <b-col  cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                                <label >Doc. de Identidad:</label>
                                
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-passport"></i></span>
                                    </div>
                                    <b-form-input placeholder="Documento"  v-model="personal.documento" required></b-form-input>
                                </b-input-group>
                                
                              
                            </b-col>
                            
                        
                        </b-row><br>
                        <b-row>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                                <label >Nombres:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-file-signature"></i></span>
                                    </div>
                                    <b-form-input placeholder="Nombre" v-model="personal.nombres" required ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                                <label >A. Paterno:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-file-signature"></i></span>
                                    </div>
                                    <b-form-input placeholder="Apellido Paterno" v-model="personal.apellidop" required></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="4">
                                <label >A. Materno:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fas fa-file-signature"></i></span>
                                    </div>
                                    <b-form-input placeholder="Apellido Materno" v-model="personal.apellidom" required ></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row><br>
                        <b-row>
                            <b-col cols="2"	sm="3"	md="4"	lg="4"	xl="12">
                                <label >Dirección:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fa fa-map-marked-alt"></i></span>
                                    </div>
                                    <b-form-input placeholder="Direccion referencia" v-model="personal.direccion" required></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row><br>
                        <b-row>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                               <label >Celular:</label> 
                               <b-input-group>
                                    
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fa fa-phone"></i></span>
                                    </div>
                                    <b-form-input placeholder="Celular" v-model="personal.celular" required ></b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="3">
                                <label >Empresa:</label>
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fa fa-building"></i></span>
                                    </div>
                                    <!-- <b-form-input placeholder="Empresa" v-model="personal.empresa"></b-form-input> -->
                                    <b-form-input
                type="text"
                v-model="user.cuenta.razonSocial"
                readonly>
              </b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">
                                <label >Sueldo:</label>
                               <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroupPrepend"><i class="fa fa-dollar-sign"></i></span>
                                    </div>
                                    <b-form-input placeholder="Sueldo" v-model="personal.sueldo"></b-form-input>
                                </b-input-group>
                            </b-col>
                            
                        </b-row><br>
                     
                    
                    </div>
                    <vue-snotify></vue-snotify> 
    </b-card-body>
     
   




    <template v-slot:footer>
       <div class="text-right">
                                    <b-btn size="sm" class="btn btn-secondary"  @click="nuevoPersonal()" ><i class="fa fa-send"></i> Guardar</b-btn>
                                </div>
      </template>
  </b-card>
</div>
 
</template>
<script>
import axios from 'axios'
import { DocPersonal } from '@/shared/utils'
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
export default {
   
      name : 'PersonalNuevo',
      data: () => {
      return {

          tipoDocumento: 1,
          documentosIdentidad: DocPersonal,
          personal: {
             
          },
          user: {
                    username: '',
                    rol: '',
                    idEmisor: '',
                    cuenta: {
                    razonSocial: '',
                    direccion: {

                    }
                    }
                },
      }

      },

      watch: {
      tipoDocumento: function () {
                if(this.tipoDocumento == '0'){
                    this.sindoc = true
                }else{
                    this.sindoc = false
                }
            },

    },
    mounted () {
        this.userData();
    },
    methods: {

            //   validador:  function () {
            //   if (this.personal.nombres.length > 0  ){
            //       return false
            //   }else {
            //       return true
            //   }

            //   },

                userData: function () {
                    this.user =  this.$store.getters.userData
                },
               nuevoPersonal: function () {
                
                axios
                .post(process.env.VUE_APP_API_URL + 'personal/insertar',{
                    token: this.$store.getters.userToken,
                    
                    tipo_documento: "01",
                    numero_documento: this.personal.documento,
                    nombres: this.personal.nombres,
                    apellido_paterno: this.personal.apellidop,
                    apellido_materno: this.personal.apellidom,
                    direccion: this.personal.direccion,
                    telefono: this.personal.celular,
                    empresa: this.user.idEmisor,
                    sueldo: this.personal.sueldo,
                })
                .then(response => (
                   
                    this.$snotify.success(response.data.msg)
                ))
                .catch(error => {
                    this.$snotify.error(error.response.data.msg.apellido_paterno[0] + ' ' + error.response.data.msg.apellido_materno[0])
                })
            },
            

    }
    
}
</script>